import { httpGet } from '@/tool/request/index';

//获取车间列表
export async function baseWsList(baseId: string) {
  return await httpGet<API.RootResponse>(`/xcx/base/wsList?baseId=${baseId}`)();
}

//获取系统列表
export async function baseSystemList(wsId: string) {
  return await httpGet<API.RootResponse>(`/xcx/base/systemList?wsId=${wsId}`)();
}

//根据基地 id获取系统列表 /base/systemListV2
export async function getBaseSystemList(baseId: string | number) {
  return await httpGet<API.RootResponse>(`/xcx/base/systemListV2?baseId=${baseId}`)();
}

//获取鱼池列表
export async function baseFishpondList(systemId: string) {
  return await httpGet<API.RootResponse>(
    `/xcx/base/fishpondList?systemId=${systemId}`
  )();
}

// ----------------------6/26----------------------
//获取所有基地列表下拉框
export async function baseBases() {
  return await httpGet<API.RootResponse>('/base/bases')({});
}

//根据基地id获取所有批次列表下拉框
export async function indexBatch(baseId: string) {
  return await httpGet<API.RootResponse>(`/index/batch?baseId=${baseId}`)();
}

//根据基地id获取所有批次列表下拉框
export async function getBatchList(params: any) {
  return await httpGet<API.RootResponse>(`/batch/batchList`)({
    params,
  });
}

//根据系统id查询设备上报关联日志
export async function batchById(params) {
  return await httpGet<API.RootResponse>(`/batch/${params.batchId}`)({
    params,
  });
}
